import Badge from "@mui/material/Badge";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import blueLeftArrow from "../../assets/icons/Basket/blue-left-arrow.svg";
import redRightArrow from "../../assets/icons/Basket/red-right-arrow.svg";
import Card from "../../components/Cards/Card";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Modal from "../../components/Modal/Modal";
import NativeObject from "../../components/NativeObject/NativeObject";
import TooltipInfo from "../../components/TooltipInfo/TooltipInfo";
import { useSelections } from "../../context/Selections";
import AnalisePdv from "./Modais/AnalisePdv";
import ConjuntosBasket from "./Modais/ConjuntosBasket";

const VennWrapper = styled.div`
  width: 100%;
  display: grid;
  margin: 10px;
  gap: 20px;
  grid-template-columns: 2fr 3fr 2fr;
`;

const ConjuntoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 230px;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px 0px;
  justify-content: center;
  .primaryButton .pdv {
    width: 100%;
    align-items: center;
    justify-content: center;
  }
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

const LayoutCardWrapper = styled("div")({
  borderRadius: "16px",
  display: "flex",
  width: "100%",
  height: "20%",
  flexGrow: 1,
  paddingRight: "10px",
  ".card": {
    margin: 0,
  },
});

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    right: 5,
    top: 4,
    border: `2px solid #38bc9a`,
    background: "#38bc9a",
    padding: "0 4px",
  },
}));

function BasketDesktop({ app, config }) {
  const { container } = config.basket;
  const [vRolutoMedida, setVRolutoMedida] = useState("");

  const [vFiltroGrupaA, setvFiltroGrupaA] = useState(0);
  const [vFiltroGrupoB, setVFiltroGrupoB] = useState(0);

  const [modalOpened, setModalOpened] = useState(false);
  const [modalOpenedPdvs, setModalOpenedPdvs] = useState(false);
  const conjuntoModal = useRef(0);
  const analiseModal = useRef(0);

  const { selections } = useSelections();

  function initialDataTable() {
    app.variable.getContent("vFiltroGrupaA", (reply) => {
      const data = reply.qContent.qString;
      setvFiltroGrupaA(data);
    });
    app.variable.getContent("vFiltroGrupoB", (reply) => {
      const data = reply.qContent.qString;
      setVFiltroGrupoB(data);
    });

    app.variable.getContent("vRolutoMedida", (reply) => {
      const data = reply.qContent.qString;
      setVRolutoMedida(data);
    });
  }

  function showModal(index) {
    conjuntoModal.current = index;
    setModalOpened(true);
  }
  function showModalPdvs(index) {
    analiseModal.current = index;
    setModalOpenedPdvs(true);
  }

  function closeModal() {
    setModalOpened(false);
  }
  function closeModalPdvs() {
    setModalOpenedPdvs(false);
  }

  useEffect(() => {
    if (app) {
      initialDataTable();
    }
  }, [selections]);

  const ModalButton = ({ title, onClick, color, pdv, tooltip, valueBadge }) => (
    <ButtonWrapper>
      <div className="primaryButton pdv" aria-hidden="true" onClick={onClick}>
        {pdv ? (
          <button
            style={{
              width: "100%",
              height: "40px",
              background: color,
              color: "#fff",
            }}
            type="button"
          >
            <div
              className="row"
              style={{
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span>{title}</span>
              {tooltip && (
                <TooltipInfo
                  text={tooltip}
                  style={{ color: "#fff", marginLeft: "8px" }}
                />
              )}
            </div>
          </button>
        ) : (
          <StyledBadge
            color="success"
            badgeContent={valueBadge > 0 ? valueBadge : 0}
            max={9}
            style={{ width: "100%" }}
          >
            <button style={{ width: "100%", height: "40px" }} type="button">
              <div
                className="row"
                style={{
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span>{title}</span>
                <i style={{ color: color }} className="fas fa-chevron-down" />
              </div>
            </button>
          </StyledBadge>
        )}
      </div>
    </ButtonWrapper>
  );

  return (
    <div className="app basket">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            {modalOpened && (
              <Modal
                title="Conjuntos"
                show={modalOpened}
                setShow={() => closeModal()}
                closeButton
              >
                <ConjuntosBasket
                  app={app}
                  config={config}
                  index={conjuntoModal.current}
                />
              </Modal>
            )}
            {modalOpenedPdvs && (
              <Modal
                title="PDVs não compradores"
                show={modalOpenedPdvs}
                setShow={() => closeModalPdvs()}
                closeButton
              >
                <AnalisePdv
                  app={app}
                  config={config}
                  index={analiseModal.current}
                />
              </Modal>
            )}
            <VennWrapper>
              {/* A */}
              <Card
                style={{
                  background: "#365698",
                  height:
                    vFiltroGrupaA > 0 && vFiltroGrupoB > 0 ? "100%" : "20%",
                }}
              >
                <ConjuntoWrapper
                  style={{
                    border: "1.09091px solid #F8F8F8",
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    padding: "8px",
                    height: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "15px",
                      borderRadius: "5px 5px 0px 0px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "header.titleId",
                          hard: "Comparar",
                        },
                      }}
                      tooltip="Comparar (Coluna Azul): Principal segmento que deseja usar como foco na comparação"
                    />
                  </div>
                  <div>
                    <ModalButton
                      title="Selecione sua análise"
                      onClick={() => showModal(0)}
                      color="#365698"
                      valueBadge={vFiltroGrupaA}
                    />
                  </div>
                </ConjuntoWrapper>
              </Card>

              {/* MSG */}
              {vFiltroGrupaA > 0 && vFiltroGrupoB > 0 ? (
                <div></div>
              ) : (
                <Card style={{ marginTop: "40px", height: "30%" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      height: "10%",
                      justifyContent: "space-between",
                      marginBottom: "30px",
                    }}
                  >
                    <div>
                      <img src={blueLeftArrow} alt="blue-left-arrow" />
                    </div>
                    <div>
                      <img src={redRightArrow} alt="red-right-arrow" />
                    </div>
                  </div>
                  <div>
                    <div>
                      <span
                        style={{
                          fontSize: "16px",
                          textAlign: "center",
                          display: "block",
                          justifyContent: "center",
                        }}
                      >
                        Todas as comparações realizadas nestes gráficos e
                        relatórios serão referenciadas pelas seleções ao lado;
                        as seleções em{" "}
                        <span
                          style={{
                            color: "#365698",
                            fontWeight: "bold",
                          }}
                        >
                          azul
                        </span>{" "}
                        chamaremos de{" "}
                        <span
                          style={{
                            color: "#365698",
                            fontWeight: "bold",
                          }}
                        >
                          Comparar (à esquerda)
                        </span>{" "}
                        e as seleções em{" "}
                        <span
                          style={{
                            color: "#F6540E",
                            fontWeight: "bold",
                          }}
                        >
                          laranja
                        </span>{" "}
                        chamaremos de{" "}
                        <span
                          style={{
                            color: "#F6540E",
                            fontWeight: "bold",
                          }}
                        >
                          Correlacionar (à direita)
                        </span>
                        .<br></br>
                        <br></br>
                        <span
                          style={{
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Atente para os gráficos e veja que todos possuem as
                          cores referenciando às seleções. Para o uso da
                          análise, estas seleções são obrigatórias.
                        </span>
                      </span>
                    </div>
                  </div>
                </Card>
              )}

              {/* B */}
              <Card
                style={{
                  background: "#F6540E",
                  height:
                    vFiltroGrupaA > 0 && vFiltroGrupoB > 0 ? "100%" : "20%",
                }}
              >
                <ConjuntoWrapper
                  style={{
                    border: "1.09091px solid #F8F8F8",
                    boxShadow:
                      "0px 2.18182px 7.63636px rgba(194, 194, 194, 0.25)",
                    borderRadius: "4.36364px",
                    background: "#fff",
                    padding: "8px",
                    height: "100%",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "15px",
                      borderRadius: "5px 5px 0px 0px",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <ComboHeader
                      reference={{
                        title: {
                          id: "header.titleId",
                          hard: "Correlacionar",
                        },
                      }}
                      tooltip="Correlacionar (Coluna Laranja): Segmento que deseja comparar com o conjunto selecionado."
                    />
                  </div>
                  <div>
                    <ModalButton
                      title="Selecione sua análise"
                      onClick={() => showModal(1)}
                      color="#F6540E"
                      valueBadge={vFiltroGrupoB}
                    />
                  </div>
                </ConjuntoWrapper>
              </Card>
            </VennWrapper>
          </LayoutCardWrapper>
          {/* CHART */}
          {vFiltroGrupaA > 0 && vFiltroGrupoB > 0 ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "100%",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Card
                expandable
                exportTable
                app={app}
                exportContainer
                exportTableId={container[1].cards[0].nativeObject.id}
                header={{
                  hardTitle: container[1].cards[0].title.hardTitle,
                }}
                style={{ width: "100%", height: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={container[1].cards[0].nativeObject.valueId}
                  reference={{
                    id: container[1].cards[0].nativeObject.id,
                  }}
                />
              </Card>
              <Card
                expandable
                exportTable
                app={app}
                exportContainer
                exportTableId={container[1].cards[1].nativeObject.id}
                header={{
                  hardTitle: container[1].cards[1].title.hardTitle,
                }}
                style={{ width: "100%", height: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={container[1].cards[1].nativeObject.valueId}
                  reference={{
                    id: container[1].cards[1].nativeObject.id,
                  }}
                />
              </Card>
            </div>
          ) : (
            <div></div>
          )}
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

BasketDesktop.defaultProps = {
  app: null,
  config: {},
};

BasketDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default BasketDesktop;
